function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import classNames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';

/**
 * Rating
 */
const Rating = props => {
  const rating = Math.floor(props.value || 0);
  const emptyStars = Math.floor(rating < 5 ? 5 - rating : 0);
  const Tag = props.tag;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tag, _extends({
    className: classNames('font-16', props.className)
  }, props, {
    id: "rating-container"
  }), [...Array(rating)].map((x, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    className: "text-warning mdi mdi-star"
  })), [...Array(emptyStars)].map((x, i) => /*#__PURE__*/React.createElement("span", {
    key: i,
    className: "text-warning mdi mdi-star-outline"
  }))), /*#__PURE__*/React.createElement(UncontrolledTooltip, {
    placement: "right",
    target: "rating-container"
  }, props.value || 0));
};

Rating.defaultProps = {
  tag: 'p'
};
export default Rating;